<div class="cancel-insurance-list">
    <div class="cancel-insurance-list__container">
        <ng-container [ngSwitch]="purchasedProduct?.productId">
            <ins-cancel-insurance-list-product
                *ngSwitchCase="productIdEnum.Car"
                [icon]="getProductIconName(purchasedProduct?.productId)"
            >
                <h3>
                    {{ purchasedProduct?.product?.productDescription | capitalize }}
                    <span>
                        {{ purchasedProduct?.product.car?.motorVehicleMake }} ({{
                            purchasedProduct?.product.car?.licensePlate | kenteken
                        }})
                    </span>
                </h3>
                <small *ngIf="purchasedProduct?.product?.startDate">
                    Ingangsdatum: {{ purchasedProduct?.product?.startDate | dateFormat }}
                </small>
                <small *ngIf="purchasedProduct?.product?.endDate">
                    Einddatum: {{ purchasedProduct?.product?.endDate | dateFormat }}
                </small>
            </ins-cancel-insurance-list-product>
            <ins-cancel-insurance-list-product
                *ngSwitchCase="productIdEnum.Moped"
                [icon]="getProductIconName(purchasedProduct?.productId)"
            >
                <h3>
                    {{ purchasedProduct?.product?.productDescription | capitalize }}
                    <span>
                        {{ purchasedProduct?.product?.moped?.motorVehicleMake }} ({{
                            purchasedProduct?.product?.moped?.licensePlate | kenteken
                        }})
                    </span>
                </h3>
                <small *ngIf="purchasedProduct?.product?.startDate">
                    Ingangsdatum: {{ purchasedProduct?.product?.startDate | dateFormat }}
                </small>
                <small *ngIf="purchasedProduct?.product?.endDate">
                    Einddatum: {{ purchasedProduct?.product?.endDate | dateFormat }}
                </small>
            </ins-cancel-insurance-list-product>
            <ins-cancel-insurance-list-product
                *ngSwitchCase="productIdEnum.Motorcycle"
                [icon]="getProductIconName(purchasedProduct?.productId)"
            >
                <h3>
                    {{ purchasedProduct?.product?.productDescription | capitalize }}
                    <span>
                        {{ purchasedProduct?.product.motorcycle?.motorVehicleMake }} ({{
                            purchasedProduct?.product.motorcycle?.licensePlate | kenteken
                        }})
                    </span>
                </h3>
                <small *ngIf="purchasedProduct?.product?.startDate">
                    Ingangsdatum: {{ purchasedProduct?.product?.startDate | dateFormat }}
                </small>
                <small *ngIf="purchasedProduct?.product?.endDate">
                    Einddatum: {{ purchasedProduct?.product?.endDate | dateFormat }}
                </small>
            </ins-cancel-insurance-list-product>
            <ins-cancel-insurance-list-product
                *ngSwitchCase="productIdEnum.Caravan"
                [icon]="getProductIconName(purchasedProduct?.productId)"
            >
                <h3>
                    {{ purchasedProduct?.product?.productDescription | capitalize }}
                    <span>
                        {{ purchasedProduct?.product?.caravan?.caravanBrand | capitalize }} ({{
                            purchasedProduct?.product?.caravan?.licensePlate | kenteken
                        }})
                    </span>
                </h3>
                <small *ngIf="purchasedProduct?.product?.startDate">
                    Ingangsdatum: {{ purchasedProduct?.product?.startDate | dateFormat }}
                </small>
                <small *ngIf="purchasedProduct?.product?.endDate">
                    Einddatum: {{ purchasedProduct?.product?.endDate | dateFormat }}
                </small>
            </ins-cancel-insurance-list-product>
            <ins-cancel-insurance-list-product
                *ngSwitchCase="productIdEnum.Home"
                [icon]="getProductIconName(purchasedProduct?.productId)"
            >
                <h3>
                    {{ purchasedProduct?.product?.productDescription | capitalize }}
                    <span>
                        {{ purchasedProduct?.product?.home?.postalCode }}
                        <span>
                            {{ purchasedProduct?.product?.home?.civicNumber
                            }}{{ purchasedProduct?.product?.home?.civicNumberSuffix }}
                        </span>
                    </span>
                </h3>
                <small *ngIf="purchasedProduct?.product?.startDate">
                    Ingangsdatum: {{ purchasedProduct?.product?.startDate | dateFormat }}
                </small>
                <small *ngIf="purchasedProduct?.product?.endDate">
                    Einddatum: {{ purchasedProduct?.product?.endDate | dateFormat }}
                </small>
            </ins-cancel-insurance-list-product>
            <ins-cancel-insurance-list-product
                *ngSwitchCase="productIdEnum.Pet"
                [icon]="getProductIconName(purchasedProduct?.productId)"
            >
                <h3>
                    {{ purchasedProduct?.product?.productDescription | capitalize }}
                    <span>{{ purchasedProduct?.product?.pet?.petName }}</span>
                </h3>
                <small *ngIf="purchasedProduct?.product?.startDate">
                    Ingangsdatum: {{ purchasedProduct?.product?.startDate | dateFormat }}
                </small>
                <small *ngIf="purchasedProduct?.product?.endDate">
                    Einddatum: {{ purchasedProduct?.product?.endDate | dateFormat }}
                </small>
            </ins-cancel-insurance-list-product>
            <ins-cancel-insurance-list-product
                *ngSwitchDefault
                [icon]="getProductIconName(purchasedProduct?.productId)"
            >
                <h3>{{ purchasedProduct?.product?.productDescription | capitalize }}</h3>
                <small *ngIf="purchasedProduct?.product?.startDate">
                    Ingangsdatum: {{ purchasedProduct?.product?.startDate | dateFormat }}
                </small>
                <small *ngIf="purchasedProduct?.product?.endDate">
                    Einddatum: {{ purchasedProduct?.product?.endDate | dateFormat }}
                </small>
            </ins-cancel-insurance-list-product>
        </ng-container>
        <div class="cancel-insurance-list__button" *ngIf="!purchasedProduct?.product?.endDate">
            <button
                class="dropdown-toggle btn btn--primary btn--sm btn--dropdown"
                (click)="onClosePanel(purchasedProduct?.productSequenceNumber)"
                *ngIf="panel.visible"
            >
                Sluiten
                <svg class="btn__icon svg-icon svg-icon--xs">
                    <use href="assets/icons-ui.svg#pijl-up-bold"></use>
                </svg>
            </button>
            <button
                class="dropdown-toggle btn btn--primary btn--sm btn--dropdown"
                (click)="onOpenPanel(purchasedProduct?.productSequenceNumber)"
                *ngIf="!panel.visible"
            >
                Opzeggen
                <svg class="btn__icon svg-icon svg-icon--xs">
                    <use href="assets/icons-ui.svg#pijl-down-bold"></use>
                </svg>
            </button>
        </div>
        <div class="cancel-insurance-list__button" *ngIf="purchasedProduct?.product?.endDate">
            <button class="btn btn--link" [disabled]="isDisabled" (click)="reviveProduct()">
                toch niet opzeggen
                <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#verwijder"></use></svg>
            </button>
        </div>
        <div class="cancel-insurance-list__panel" *ngIf="errors.length">
            <cyno-alert [errors]="errors"></cyno-alert>
        </div>
        <div class="cancel-insurance-list__panel">
            <ins-panel-expandable
                class="panel--info"
                id="{{ purchasedProduct?.productSequenceNumber }}"
                direction="right"
                [hasBorder]="false"
            >
                <wuc-balloon
                    *ngIf="panel.visible"
                    [arrowPosition]="(isScreenSmall$ | async) ? 'topLeft' : 'topRight'"
                    padding="large"
                    [isFullWidth]="true"
                >
                    <ins-insurance-end-product-form
                        *ngIf="!isVehicle"
                        [purchasedProduct]="purchasedProduct"
                    ></ins-insurance-end-product-form>
                    <ins-insurance-end-product-vehicle-form
                        *ngIf="isVehicle"
                        [purchasedProduct]="purchasedProduct"
                    ></ins-insurance-end-product-vehicle-form>
                </wuc-balloon>
            </ins-panel-expandable>
        </div>
    </div>
</div>
